import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Col, Form as AntForm, Row } from "antd";
import { motion } from "framer-motion";
import { debounce } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import { onBoardTransition } from "../../animation/index";
import {
  ADD_SERVICE,
  GET_SERVICE_TYPES,
  PLACE_DETAIL,
  PLACE_SEARCH,
} from "../../app/apollo/index";
import { StepProp } from "../../constants/interfaces";
import { Label } from "../../globalComponents/globalStyle";
import { LoggerButton, TextInput } from "../../globalComponents/Index";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { Dropdown, InputDiv, Option, StyledAutoComplete } from "./Style";

interface Logintype {
  email: string;
  password: string;
}

export const Step2: React.FC<StepProp> = (props) => {
  const [category, setCategory] = React.useState<any>();
  const [placeSearchValues, setPlaceSearchValue] = React.useState<any>();
  const [placeSearchLocation, setPlaceSearchLocation] = React.useState<any>();
  const [load, setload] = React.useState(false);
  const { data, loading, error } = useQuery(GET_SERVICE_TYPES);
  const [createService] = useMutation(ADD_SERVICE);
  const [placeSearch, placeSearchData] = useLazyQuery(PLACE_SEARCH);
  const [placeDetails, PlaceDetailsData] = useLazyQuery(PLACE_DETAIL);

  //   console.log("the data is", loading ? " loading... " : data);
  React.useEffect(() => {
    setCategory(data?.getServiceCategory);
  }, [data]);
  console.log("sample category is", category);
  const history = useHistory();
  console.log("the state", category);
  const onChange = async (value: string) => {
    console.log("the value is ", value);
    try {
      placeSearch({
        variables: {
          place: value,
        },
      });
    } catch (e: any) {
      console.log("error", e);
    }
  };
  const debounceOnChange = React.useCallback(debounce(onChange, 1000), []);
  React.useEffect(() => {
    setPlaceSearchLocation(
      PlaceDetailsData?.data?.placeDetail?.geometry?.location
    );
  }, [placeSearchData]);
  console.log("location", placeSearchLocation);
  const onFinisher = async (e: any, options: any) => {
    console.log("onfinisher console", options);
    setPlaceSearchValue(options);
    try {
      placeDetails({
        variables: {
          place_id: options.key,
        },
      });
    } catch (e) {
      console.log(e);
    }
    //   setPlaceSearchValue(options)
  };

  console.log("place Details values", PlaceDetailsData);

  const onFinish = async (values: any) => {
    setload(true);
    console.log(values);
    try {
      const response = await createService({
        variables: {
          name: values.businessName,
          serviceType_id: Number(values.businessType),
          //   mobile:3,
          location: [
            {
              locationName: placeSearchValues.value,
              lat: placeSearchLocation.lat,
              lng: placeSearchLocation.lng,
            },
          ],
          email: values.businessMail,
        },
      });
      console.log("create service response is", response);
      if (response) {
        setload(false);
        if (response?.data?.createService?.success) {
          NotificationAlert(
            "success",
            "Success",
            response?.data?.createService?.msg
          );
          history.replace("/destination");
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.createService?.msg
          );
        }
      }
      setload(false);
    } catch (e: any) {
      setload(false);
      NotificationAlert("error", "Error", "Try again later");
      console.log(e.message);
    }
    // history.replace("/destination");
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };

  return (
    <motion.div
      variants={onBoardTransition}
      exit="out"
      animate="in"
      initial="initial"
    >
      <AntForm
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <AntForm.Item
          name="businessType"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Business Type</h3>
            </Label>
          }
        >
          <InputDiv>
            <Dropdown required>
              <option value="" />
              {category?.map((categories: any) => (
                <Option key={categories.id} value={categories.id}>
                  {categories.serviceCategory}
                </Option>
              ))}
            </Dropdown>
          </InputDiv>
        </AntForm.Item>
        <AntForm.Item
          name="businessName"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Business Name</h3>
            </Label>
          }
        >
          <div>
            <TextInput
              required={true}
              type="text"
              placeholder="Enter business name"
              name="businessName"
            />
          </div>
        </AntForm.Item>
        <AntForm.Item
          name="businessAddress"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Business Address</h3>
            </Label>
          }
        >
          <InputDiv>
            <StyledAutoComplete
              onChange={debounceOnChange}
              onSelect={onFinisher}
              placeholder="Enter business address"
            >
              {placeSearchData?.loading ? (
                <StyledAutoComplete.Option value={""}>
                  Loading...
                </StyledAutoComplete.Option>
              ) : (
                placeSearchData?.data?.placeSearch?.predictions.map(
                  (val: any) => (
                    <StyledAutoComplete.Option
                      key={val?.place_id}
                      value={val?.description}
                    >
                      {val?.description}
                    </StyledAutoComplete.Option>
                  )
                )
              )}
            </StyledAutoComplete>
          </InputDiv>
        </AntForm.Item>
        <AntForm.Item
          name="businessMail"
          rules={[
            {
              required: true,
              message: "field is required",
            },
          ]}
          label={
            <Label>
              <h3>Business Mail</h3>
            </Label>
          }
        >
          <div>
            <TextInput
              required={true}
              type="email"
              placeholder="Enter business mail"
              name="businessMail"
            />
          </div>
        </AntForm.Item>

        <br />
        <Row justify="space-between">
          <Col xs={{ span: 9 }}>
            {" "}
            <LoggerButton
              onClick={props.back}
              colorProp={true}
              width="100%"
              text="Back"
            />
          </Col>
          <Col xs={{ span: 9 }}>
            {" "}
            <LoggerButton
              loading={load}
              htmlType="submit"
              width="100%"
              text="Next"
            />
          </Col>
        </Row>
      </AntForm>
    </motion.div>
  );
};
